import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as LegacyThemeProvider } from "@mui/styles";
import rightworkTheme from "./rightworkTheme";

// Material v5 and legacy styles v6 use separate private theme contexts.
// Keep both consumers on the same brand tokens while legacy styles remain.
export default function RightworkThemeProvider({ children }) {
  return <LegacyThemeProvider theme={rightworkTheme}>
    <ThemeProvider theme={rightworkTheme}>{children}</ThemeProvider>
  </LegacyThemeProvider>;
}
